// Modules
import React, { Component } from 'react';
import moment, { Moment } from "moment"
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import './PointsCalendar.scss';

// Components
import Calendar from '../Calendar';
import MvSelect from 'Generic/MvSelect';

interface IProps {
    data: any;
    startDate?: any;
    // endDate?:any;
    // searchMonths?: any;
    // enabledDates: (string | Date)[];
    // numberOfMonths?:number;
    activeDate: Date | null;
    rangeStartDate?: string;
    rangeEndDate?: string;
}

interface IState {
    selectedMonth: Moment;
    showModal: boolean;
    searchMonths: any,
    selectedYear: number;
}

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
class PointsCalendar extends Component<IProps, IState> {

    public static defaultProps= {
        selectedMonths: [],
        availableDates: [],
        numberOfMonths: 1
    }

    constructor(props: IProps) {
        super(props);
        this.nextMonth = this.nextMonth.bind(this);
        this.previousMonth = this.previousMonth.bind(this);
        this.setCalendarPosition = this.setCalendarPosition.bind(this);
        this.handleInput = this.handleInput.bind(this);

        this.state = {
            selectedMonth: moment(props.startDate).set('month', this.getStartMonth()),
            showModal: false,
            searchMonths: "",
            selectedYear: Number(moment(props.startDate).format('YYYY'))
          };
    }

    componentDidMount(){
        this.createActiveMonths()
    }

    // componentDidUpdate() {
    //     this.createDatePointsObject()
    // }

   createDatePointsObject() {
    let selectedRoom:any = []

 
    this.props.data.map((date: any) => {    
        if (date.daily) {
            date.daily.map((dateAndPoints:any) => {
                let formattedDate = moment(dateAndPoints.date).toDate()
                selectedRoom.push({"dates": formattedDate, "points": dateAndPoints.points})
            })
        }
    })

    return selectedRoom
     
   }

    createActiveMonths() {
        let activeMonths:any = []
        this.props.data.map((date: any) => {
            let month:any = moment(date.month +"/01/" + date.year).toDate()
            activeMonths.push(month)
            activeMonths = activeMonths.sort((a:any, b:any)=> a - b)  
        })

        this.setState({
            searchMonths: activeMonths
        })
    }

    nextMonth() {
        if(!this.checkDisableNext()) {
            if(this.state.selectedMonth.month() === 0) {
                this.setState({ selectedYear: this.state.selectedYear + 1 })
            }
            this.setState({ selectedMonth: this.state.selectedMonth.add('month', 1) })
            // this.props.refreshAvailability(this.state.selectedMonth)
        }
    }

    previousMonth() {
        if(!this.checkDisablePrev()) {
            if(this.state.selectedMonth.month() === 1) {
                this.setState({ selectedYear: this.state.selectedYear - 1 })
            }
            this.setState({ selectedMonth: this.state.selectedMonth.subtract('month', 1) })
            // this.props.refreshAvailability(this.state.selectedMonth)

        }
     }

    getStartMonth = () => {
        return this.props.data.sort((a: any, b: any) => {
            if (a.year === b.year) {
                return a.month < b.month ? -1 : 1
            } else {
                return a.year < b.year ? -1 : 1
            }
        }).map((m: any) => {
            if (!m.month) return 0
            // return moment().set('month', m.month).get('month')
            return parseInt(m.month)
        })[0];
    };

    getEndMonth = () => {
        return this.props.data.sort((a: any, b: any) => {
            if (a.year === b.year) {
                return a.month < b.month ? 1 : -1
            } else {
                return a.year < b.year ? 1 : -1
            }
        }).map((m: any) => {
            if (!m.month) return 0
            // return moment().set('month', m.month).get('month')
            return parseInt(m.month)
        })[0];
    };

    checkDisablePrev():boolean {
        if(this.props.data.length > 1 && this.state.selectedMonth.get('month') !== this.getStartMonth()){
          return false
        }

        return true
    }

    checkDisableNext(): boolean {
        if(this.props.data.length > 1 && this.state.selectedMonth.get('month') !== this.getEndMonth()){
            return false
        }
        return true
    }


    setCalendarPosition( selectedMonth: Moment){
        this.setState({ selectedMonth: selectedMonth });
    }

    getDateForPosition(): Moment {
        let startingDate = moment(this.state.selectedMonth || this.props.startDate);
        return startingDate;
    }

    handleInput(e:any){
        const target = e.target;
        let value = target.value;
        this.setCalendarPosition(moment(value))
    }
    

    render() {
        let dateAndPoints = this.createDatePointsObject()
       
        // convert these from Moments back to JS dates
        let year = this.state.selectedYear
        let month = this.getDateForPosition().subtract('month', 1).toDate().getMonth()

        const disableNext = this.checkDisableNext();
        const disablePrev = this.checkDisablePrev();

        return (
            <div className="points-calendar">
                <div className="calendar-wrapper">
                    <div className="date-picker-nav">
                        <button className={`${disablePrev ? 'disabled ' : ''}date-picker-prev date-picker-nav-button`} onClick={this.previousMonth}>previous month</button>
                        <div className="month-container">
                            <h3>{`${monthNames[month]} ${year}`}</h3>
                        </div>
                        <button className={`${disableNext ? 'disabled ' : ''}date-picker-next date-picker-nav-button`} onClick={this.nextMonth}>next month</button>
                      
                    </div>
                    <div  className="calendar-container">
                        <Calendar
                            year={year}
                            month={month}
                            enabledDates={dateAndPoints}
                            activeDate={this.props.activeDate}
                            rangeStartDate={this.props.rangeStartDate}
                            rangeEndDate ={this.props.rangeEndDate} 
                        />
                    </div>
                </div>
             
            </div>
        );
    }
}
PointsCalendar.contextType = LocalizationContext;
export default PointsCalendar;
